<ng-container *ngIf="retirementData">
  <div
    *ngIf="retirementData.contractSummaryResponse && retirementData.contractSummaryResponse.responseCode=='200' && retirementData.contractSummaryResponse.contractSummary">
    <div class="container"
      *ngFor="let contract of retirementData.contractSummaryResponse.contractSummary; let i = index">
      <div class="product-box col-xs-12 pt-4 pb-4" id="{{contract.contractID | setAnchor:contract.lineOfBusiness}}"
        [attr.data-ct-analytics]="contract.contractID"
        [attr.data-qa]="contract.enable2FA ? 'retirement_eb_plan_product-box' : 'retirement_product-box'"
        *ngIf="contract.status && contract.status.toLowerCase() !='suppress' && contract.status.toLowerCase() !='pending'"
        [attr.data-analytics]="'0|'+(i+1)">
        <h3 class="h4 product-title mt-0" [attr.data-qa]="'retirement_product-title'">
          <span class="product-title-lob product-subtitle">{{contract.lineOfBusiness || "Retirement"}}</span>
        </h3>
        <div class="row contract-header">
          <div class="col-xs-12 col-md-7 product-title">
            <h4 class="h2">
              <ng-container *ngIf="contract.enable2FA; else notHrt">
                <a class="product-title-type two-factor-modal" href="javascript:void(0);" two-factor-auth-modal
                  [contract]="contract" [modalId]="'2fa_'+contract.contractID+'_'+i"
                  [attr.data-qa]="'retirement_viewDetails_link'">
                  <span class="transclude-content two-factor-modal product-name text-capitalize"
                    [attr.data-qa]="'retirement_product-type'" [innerHTML]="contract.productType"
                    *ngIf="contract.productType"></span>
                  <span class="sr-only">opens a modal dialog</span>
                  <!--subStringToLowerCase-->
                </a>
              </ng-container>
              <ng-template #notHrt>
                <!-- <a class="product-subtitle product-account" [href]="contract.contractDetailLink">{{contract.primaryContractValue.title}}</a> -->
                <a class="product-title-type" [attr.href]="contract.contractDetailLink"
                  [attr.data-qa]="'retirement_product-contractDetailLink'">
                  <span class="product-name text-capitalize"
                    [attr.data-qa]="'retirement_contractDetailLink_product-type'" [innerHTML]="contract.productType"
                    *ngIf="contract.productType"></span>
                  <!--subStringToLowerCase-->
                </a>
              </ng-template>
            </h4>
            <div class="h4 product-title-lob-inner" *ngIf="contract.productTitle"
              [attr.data-qa]="'retirement_productTitleCode'">
              <span class="product-subtitle"
                *ngIf="!contract.productTitleCode || 
              (contract.productTitleCode && contract.productTitleCode.toLowerCase() !== 'lbnone')">{{contract.productTitle}}</span>
              <a class="product-subtitle" [href]="contract.contractDetailLink"
                *ngIf="contract.lineOfBusiness.toLowerCase() != 'retirement'"
                [attr.data-qa]="'retirement_productTitleCode_product-title'">
                <span class="sr-only">Account Number: </span> #{{contract.contractID | mask:contract.maskContractID}}
              </a>
            </div>

          </div>
          <div class="col-xs-12 col-md-5 text-right-md text-right-lg sm-btm-20">

            <div class="row">
              <div class="col-sm-12">
                <ng-container *ngIf="contract.contractDetailLink">
                  <ng-container *ngIf="contract.enable2FA; else notHrt">
                    <a class="btn btn-primary quick-actions two-factor-modal" href="javascript:void(0);"
                      two-factor-auth-modal [contract]="contract" [modalId]="'2fa_'+contract.contractID+'_'+i"
                      [attr.data-qa]="'retirement_viewDetails_link'">
                      <span class="transclude-content two-factor-modal">View Details
                        <span class="sr-only"> opens a modal dialog</span></span></a>
                  </ng-container>
                  <ng-template #notHrt>
                    <a class="btn btn-primary quick-actions" [attr.data-qa]="'retirement_viewDetails_nohrt-link'"
                      [href]="contract.contractDetailLink">View Details</a>
                  </ng-template>
                </ng-container>
                <div class="btn-group quick-actions"
                  *ngIf="contract.accountActions && contract.accountActions.length > 0">
                  <button type="button" [attr.data-qa]="'retirement_quick-actions'"
                    class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false"
                    aria-haspopup="true">Quick Actions
                    <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-right" [attr.data-qa]="'retirement_quick-actions-ul'"
                    role="menu">
                    <li *ngFor="let action of contract.accountActions; let idx = index"
                      [attr.data-qa]="'retirement_quick-actions-li'"
                      [hidden]="action.actionTitle == 'View My Coverage' && contract.lineOfBusiness == 'Life Insurance'">
                      <a [href]="action.actionTarget"
                        (click)="_genericService.openSecondary($event, action.linkTarget, action.actionTarget, action.popupWidth, action.popupHeight)"
                        role="menuitem">{{action.actionTitle}}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

            </div>

          </div>
        </div>
        <ng-container *ngIf="contract.contractID">
          <ret-account-messaging *featureToggle="'amEnabled'" [contractId]="contract.contractID"
            [additionalValues]="contract.additionalValues"></ret-account-messaging>
        </ng-container>

        <div class="alert alert-info alert-inline mt-3" role="alert" [attr.data-qa]="'retirement_pendingssira'"
          *ngIf="contract && contract.lia && contract.lia.toLowerCase() === 'pendingssira'">
          <span class="sr-only">info</span>
          <h2 class="h3 alert-title">You're Almost There!</h2>
          <p class="msg-body">
            Review your application and accept the agreement to finish opening your account.
          </p>
          <p *ngIf="contract.contractDetailLink">
            <a [href]="contract.contractDetailLink"><strong>Review & Approve</strong></a>
          </p>
        </div>

        <div class="row"
          *ngIf="contract.userMsg && (contract.status && (contract.status.toLowerCase() == 'warning' || contract.status.toLowerCase() == 'blocked'))">
          <div class="col-sm-12 hidden-xs">
          </div>
          <div class="col-sm-12 hidden-xs" *ngIf="contract.userMsg">
            <div class="alert alert-info alert-inline" role="alert" [attr.data-qa]="'retirement_userMsg'">
              <span class="sr-only">warning</span>
              <p class="msg-body">{{contract.userMsg}}</p>
            </div>
          </div>
        </div>
        <div class="row"
          *ngIf="contract.status && (contract.status.toLowerCase() == 'success' || contract.status.toLowerCase() == 'warning')">
          <div class="col-sm-12 hidden-xs">
          </div>
          <div class="col-sm-12" *ngIf="contract.alertMessages">
            <div *ngFor="let alert of contract.alertMessages; let idx = index">

              <div *ngIf="alert.messageType && alert.messageType.toLowerCase() == 'alert'">
                <div class="alert alert-info alert-inline external-alerts" role="alert"
                  *ngIf="alert.messageSourceEndPoint; else serviceMessageData">
                  <span class="sr-only">Info</span>
                  <ng-container *ngIf="alert.messageSourceEndPoint.indexOf('NQ_Enrollee') > -1">
                    <h2 class="h3 alert-title">Enroll Now</h2>
                    <p>You are now eligible to make your enrollment elections for the Non-Qualified program. This
                      option
                      is available for a limited time.</p>
                    <p><strong><a name="Get Started"
                          [href]="contract.accountActions && contract.accountActions.length > 0 ? contract.accountActions[0].actionTarget : contract.contractDetailLink">Get
                          Started</a></strong>
                    <p>
                  </ng-container>
                </div>
                <ng-template #serviceMessageData>
                  <div class="alert alert-{{alert.alertType?alert.alertType:'warning'}} alert-inline"
                    [attr.data-qa]="'retirement_contractDetailLink_alertMessage'" role="alert"
                    *ngIf="alert.messageType && alert.messageType.toLowerCase() == 'alert'">
                    <span class="sr-only">{{alert.alertType?alert.alertType:'warning'}}</span>
                    <h2 class="h3 alert-title">{{alert.messageTitle? alert.messageTitle:'Alert:'}}</h2>
                    <p class="msg-body">{{alert.messageBody }}</p>
                    <p *ngIf="alert.messageLink">
                      <a [href]="alert.messageLink">{{alert.messageLinkLabel?alert.messageLinkLabel:'View Details'}}
                        <span class="sr-only"> on {{alert.messageTitle? alert.messageTitle:'Alert'}}</span>
                      </a>
                    </p>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>

          <div class="col-xs-12"
            *ngIf="!contract.primaryContractValue || (contract.primaryContractValue && contract.primaryContractValue.value === undefined && (contract.primaryContractValue.valueType===undefined || contract.primaryContractValue.valueType.toLowerCase() != 'hide')) && !(contract.userMsg)">
            <div class="alert alert-warning alert-inline" role="alert" [attr.data-qa]="'retirement_alert_userMsg'">
              <span class="sr-only">Warning</span>
              <h2 class="h3 alert-title">Alert:</h2>
              <div class="msg-body">
                <error-msg [lob]="compData.businessUnit" msgcode="tech"></error-msg>
              </div>
            </div>
          </div>
          <div class="col-xs-12 product-top mb-2"
            *ngIf="(contract.primaryContractValue && contract.primaryContractValue.title) || (contract.secondaryContractValues && contract.secondaryContractValues[0] && contract.secondaryContractValues[0].group)">
            <div class="row">
              <!-- <div class="col-sm-5"> -->
              <div [ngClass]="redesign?'col-sm-6':'col-sm-5'">
                <div class="pt-2" *ngIf="contract.primaryContractValue?.valueType?.toLowerCase() != 'hide'">
                  <span class="account-value-link">
                    <span class="product-primary" [attr.data-qa]="'retirement_product-primary-title'">
                      <span class="small"
                        *ngIf="contract.contractDetailLink && contract.primaryContractValue && contract.primaryContractValue.title">
                        <ng-container *ngIf="contract.enable2FA; else notHrt">
                          <a class="product-subtitle product-account two-factor-modal" href="javascript:void(0);"
                            two-factor-auth-modal [contract]="contract" [modalId]="'2fa_'+contract.contractID+'_'+i"
                            [attr.data-qa]="'retirement_product-subtitle-viewDetails'">
                            <span
                              class="transclude-content two-factor-modal">{{contract.primaryContractValue.title}}</span>
                            <span class="sr-only">opens a modal dialog</span></a>
                        </ng-container>
                        <ng-template #notHrt>
                          <a class="product-subtitle product-account"
                            [href]="contract.contractDetailLink">{{contract.primaryContractValue.title}}</a>
                        </ng-template>
                        <!-- <a class="product-subtitle product-account" [href]="contract.contractDetailLink">{{contract.primaryContractValue.title}}</a> -->
                      </span>
                    </span>
                    <pru-tooltip
                      *ngIf="contract.primaryContractValue && contract.primaryContractValue.titleToolTip && contract.primaryContractValue.title"
                      [definitionID]="contract.primaryContractValue.titleToolTip.definitionID"
                      [definitionLocation]="contract.primaryContractValue.titleToolTip.definitionLocation"
                      [clickTitle]="contract.primaryContractValue.title | toolTipFormat"
                      [screenReaderText]="contract.primaryContractValue.title"
                      [analyticData]="contract.primaryContractValue.title"
                      [attr.data-qa]="'retirement_retirement-pru-tooltip'">
                    </pru-tooltip>
                  </span>
                  <p class="product-primary mb-0 pt-3" [ngClass]="{'sm-no-border': contract.noSecondary}"
                    [attr.data-qa]="'retirement_primaryContractValue'">
                    <span class="primary-value"
                      *ngIf="contract.primaryContractValue && contract.primaryContractValue.value && contract.primaryContractValue.valueType">
                      <span
                        *ngIf="contract.primaryContractValue.valueType.toLowerCase() == 'amount'">{{contract.primaryContractValue.value
                        | currency:'USD':'symbol-narrow':'1.2-2'}}</span>
                      <span
                        *ngIf="contract.primaryContractValue.valueType.toLowerCase() == 'restrictedamount'">${{contract.primaryContractValue.value}}</span>
                      <span
                        *ngIf="contract.primaryContractValue.valueType.toLowerCase() == 'amount' || contract.primaryContractValue.valueType.toLowerCase() == 'restrictedamount'">
                        <span *ngIf="contract.primaryContractValue.descPos; else nodescpos">
                          <span class="smaller"
                            *ngIf="contract.primaryContractValue.descPos=='inline'">{{contract.primaryContractValue.valueDesc}}</span>
                        </span>
                        <ng-template #nodescpos>
                          <span class="smaller"
                            *ngIf="contract.primaryContractValue && contract.primaryContractValue.title && contract.primaryContractValue.title.toLowerCase()=='guaranteed lifetime income'">/yr</span>
                        </ng-template>
                      </span>
                      <span *ngIf="contract.primaryContractValue.valueType.toLowerCase() == 'date' 
                            || contract.primaryContractValue.valueType.toLowerCase() == 'text' 
                            || contract.primaryContractValue.valueType.toLowerCase() == 'notavailable'"
                        [ngClass]="{'alert-warning alert-text': contract.primaryContractValue.value && contract.primaryContractValue.valueType.toLowerCase() == 'notavailable'}">
                        {{contract.primaryContractValue.value}}
                      </span>
                    </span>
                  </p>
                  <p class="product-primary mb-0"
                    [ngClass]="{'product-border': contract.secondaryContractValues, 'mt-3': redesign}"
                    [attr.data-qa]="'retirement_asOfDate'">
                    <span class="small product-subtitle contract-date" *ngIf="contract.asOfDate">As of
                      {{contract.asOfDate}}</span>
                  </p>
                  <ng-container
                    *ngIf="ndgCnt && contract.primaryContractValue && contract.primaryContractValue.value && contract.primaryContractValue.valueType">
                    <div class="nudge-msg mt-4">
                      <div class="row">
                        <div class="col-sm-6 pr-0">
                          <p>{{ndgCnt.desc}}</p>
                        </div>
                        <div class="col-sm-6">
                          <p class="cta-rt"><a [href]="ndgCnt.CTAUrl" [class]="ndgCnt.CTAStyle" [target]="ndgCnt.target"
                              [rel]="ndgCnt.target=='_self'? null: 'noopener noreferrer'">{{ndgCnt.CTATxt}}<ng-container
                                *ngIf="ndgCnt.target=='_blank'"><span class="sr-only"> opens in a new window</span>
                              </ng-container></a></p>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>

              </div>
              <div class="product-secondary" [ngClass]="redesign?'col-sm-6':'col-sm-7'"
                *ngIf="contract.secondaryContractValues">
                <ul class="list-unstyled secondarygroup" [attr.data-qa]="'retirement_secondary_ul'"
                  *ngFor="let secondarygroup of contract.secondaryContractValues; let idx = index">
                  <li *ngFor="let secondary of secondarygroup.group" [attr.data-qa]="'retirement_secondary_li'"
                    [ngClass]="redesign? 'mb-3':''">
                    <secondary-values *ngIf="secondary" [secondaryElement]="secondary" [productTypeCode]="">
                    </secondary-values>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>
        <div class="row" *ngIf="contract.status && contract.status.toLowerCase() == 'error'">
          <div class="col-sm-12" *ngIf="contract.userMsg">
            <div class="alert alert-warning alert-inline" role="alert" [attr.data-qa]="'retirement_contract_dataErr'">
              <span class="sr-only">{{contract.userMsg || 'Data Error'}}</span>
              <p>{{contract.userMsg || 'Data Error'}}</p>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="contract.status && contract.status.toLowerCase() == 'missing'">
          <div class="col-sm-12">
            <div class="alert alert-warning alert-inline" role="alert" [attr.data-qa]="'retirement_contract_missing'">
              <span class="sr-only">warning</span>
              <error-msg [lob]="retirementData.businessUnit" msgcode="missing"></error-msg>
            </div>
          </div>
        </div>
        <!-- <ng-container *featureToggle="'ricWcEnabled'">
          <div class="row">
            <div class="col-xs-12">
              <pru-ric-banner *ngIf="displayRic && singleRet" [ssoid]="123456" [inContainer]=true
                [retirementDomain]="retirementDomain">
              </pru-ric-banner>
            </div>
          </div>

        </ng-container> -->
        <div class="row" *ngFor="let alertMessage of contract.alertMessages;">
          <div class=" col-sm-12 text-right" *ngIf="alertMessage.messageType == 'VirtualInbox'">
            <a class="auth-link mb-2 sm-block" [attr.data-qa]="'retirement_VirtualInbox_link'"
              [href]="alertMessage.messageLink"
              (click)="_genericService.openSecondary($event, alertMessage.messageTarget, alertMessage.messageLink, alertMessage.popupWidth, alertMessage.popupHeight) ">
              <span class="fa fa-envelope "></span>
              <span
                *ngIf="(alertMessage.newMessageIndicator && alertMessage.newMessageIndicator.toLowerCase()) !='true' ">
                Message Center</span>
              <span
                *ngIf="(alertMessage.newMessageIndicator && alertMessage.newMessageIndicator.toLowerCase())=='true' ">
                New Message</span>
              <span *ngIf="(alertMessage.messageTarget && alertMessage.messageTarget.toLowerCase()) !='self'"
                class="sr-only"> opens in new window</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- contractsummary v2 CSR non-privileged user -->
    <ng-container *ngIf="!retirementData.contractSummaryResponse.contractSummary">
      <div class="container" *ngIf="_genericService.usr_csr">
        <div class="product-box col-xs-12 pt-4 pb-4" [attr.data-ct-analytics]="service-error">
          <div class="row contract-header">
            <div class="col-sm-6 col-md-8 product-title">
              <h3 class="h4 mt-0" [attr.data-qa]="'retirement_businessUnit'">
                <span class="product-title-lob">{{retirementData.businessUnit}}</span>
              </h3>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="alert alert-danger alert-inline" role="alert" [attr.data-qa]="'retirement_warning_container'">
                <span class="sr-only">warning</span>
                <error-msg msgcode="csr"></error-msg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="retirementData.responseCode != 200; else successNoData">
    <div class="container" [attr.data-qa]="'ucd-error-container'">
      <div class="product-box col-xs-12 pt-4 pb-4" [attr.data-ct-analytics]="service-error">
        <h3 class="h4 product-title mt-0" [attr.data-qa]="'ucd-error-buName'">
          <span class="product-title-lob">{{retirementData.businessUnit}}</span>
        </h3>
        <div class="row contract-header">
          <div class="col-sm-6 col-md-8"></div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="alert alert-danger alert-inline" role="alert" [attr.data-qa]="'ucd-error-alertbox'">
              <span class="sr-only">warning</span>
              <ng-container *ngIf="_genericService.usr_csr; else client">
                <div class="csr-err-msg" [attr.data-qa]="'ucd-csr-error-text'">
                  <error-msg [lob]="retirementData.businessUnit" msgcode="missing"
                    *ngIf="retirementData.responseCode != 412">
                  </error-msg>
                  <error-msg msgcode="csr" *ngIf="retirementData.responseCode == 412"></error-msg>
                </div>
              </ng-container>
              <ng-template #client>
                <div [attr.data-qa]="'ucd-error-p-text'" class="client-err-msg">
                  <error-msg [lob]="retirementData.businessUnit" msgcode="missing"></error-msg>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #successNoData>
    <div
      *ngIf="!retirementData.contractSummaryResponse || retirementData.contractSummaryResponse.responseCode!='200' || !retirementData.contractSummaryResponse.contractSummary">
      <div class="container">
        <div class="product-box col-xs-12 pt-4 pb-4" [attr.data-ct-analytics]="service-error">
          <div class="row contract-header">
            <div class="col-sm-6 col-md-8 product-title">
              <h3 class="h4 mt-0" [attr.data-qa]="'retirement_businessUnit'">
                <span class="product-title-lob">{{retirementData.businessUnit}}</span>
              </h3>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="alert alert-danger alert-inline" role="alert" [attr.data-qa]="'retirement_warning_container'">
                <span class="sr-only">warning</span>
                <ng-container *ngIf="_genericService.usr_csr; else client">
                  <div class="csr-err-msg">
                    <ng-container
                      *ngIf="!retirementData.portfolioResponse || (retirementData.portfolioResponse && retirementData.portfolioResponse.responseCode === '200' && retirementData.portfolioResponse.portfolio && retirementData.portfolioResponse.portfolio.contracts && retirementData.portfolioResponse.portfolio.contracts.length === 0); else techDifficulty">
                      <error-msg msgcode="csr"></error-msg>
                    </ng-container>
                    <ng-template #techDifficulty>
                      <error-msg [lob]="retirementData.businessUnit" msgcode="missing"></error-msg>
                    </ng-template>
                  </div>
                </ng-container>
                <ng-template #client>
                  <div class="client-err-msg">
                    <error-msg [lob]="retirementData.businessUnit" msgcode="missing"></error-msg>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- <ng-container *featureToggle="'ricWcEnabled'">
    <pru-ric-banner *ngIf="displayRic && !singleRet" [ssoid]="123456" [retirementDomain]="retirementDomain">
    </pru-ric-banner>
  </ng-container> -->

</ng-container>
<ng-container *featureToggle="'acEnabled'">
  <ret-additonal-accounts></ret-additonal-accounts>
</ng-container>